import { pdfjs } from 'react-pdf'

// Worker is copied to public/ at build time by copy-webpack-plugin
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

export { pdfjs }
